export const usePreOrder = (platform: General.Platform, isPreOrder?: boolean) => {
  return isPreOrder && ['lazada', 'tiktok', 'tiktok_us'].includes(platform);
};
